export enum AccessRightTabs {
    All = 1, // todo deprecated
    QuickChoice = 2,
    ManualChoice = 3,
}
